/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Groups_BuildingsInputs */



/**
* | output |
* | --- |
* | "Sub-group buildings" |
*
* @param {Sub_Groups_BuildingsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const sub_groups_buildings = /** @type {((inputs?: Sub_Groups_BuildingsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Groups_BuildingsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sub-group buildings")
	return /** @type {LocalizedString} */ ("Bâtiments des sous-groupes")
});